exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".link-item{border-radius:3px;display:inline-block;position:relative;margin-right:calc((100% - 480px)/2);margin-top:10px}.link-item:hover{background-color:#eee}.link-item__link{display:block;cursor:pointer;padding:10px 40px 70px;width:10pc}.link-item__icon{position:relative}.link-item__counter{position:absolute;width:24px;text-align:center;height:24px;padding:0 5px;line-height:24px;background-color:#ff3b30;color:#fff;border-radius:9pt;top:0;right:0;cursor:default;font-size:1rem}.link-item__title{position:absolute;left:50%;transform:translateX(-50%);margin:0;width:10pc;height:42px;font-size:1pc;font-weight:400;font-style:normal;font-stretch:normal;line-height:22px;letter-spacing:normal;text-align:center;color:#333}@media screen and (min-width:760px){.link-item{display:inline-block;position:relative;margin-right:calc((100% - 640px)/3)}}@media screen and (min-width:992px){.link-item{display:inline-block;position:relative;margin-right:calc((100% - 960px)/5)}.link-item:nth-child(6n){margin-right:0}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/containers/App/screens/Tube/screens/Index/components/LinkItem/style.css
 ** module id = 2736
 ** module chunks = 72
 **/